@if (totalElements() > 0) {
  <div class="app-pagination__title">
    {{ itemsRange().from + '-' + itemsRange().to + ' of ' + totalElements() }}
  </div>
}

<div class="app-pagination__controls">
  <button
    [disabled]="isFirstPage()"
    (click)="goToFirstPage()"
  >
    <svg icon="pagination-first" />
  </button>

  <button
    [disabled]="isFirstPage()"
    (click)="goToPreviewPage()"
  >
    <svg icon="pagination-back" />
  </button>

  <button
    [disabled]="isLastPage()"
    (click)="goToNextPage()"
  >
    <svg icon="pagination-next" />
  </button>

  <button
    [disabled]="isLastPage()"
    (click)="goToLastPage()"
  >
    <svg icon="pagination-last" />
  </button>
</div>
